'use strict';

var React = require('react');

var SvgDisabledIcon = function SvgDisabledIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Zm-3.677 4.383a5.5 5.5 0 0 1-7.706-7.706l7.706 7.706Zm1.06-1.06-7.706-7.706a5.5 5.5 0 0 1 7.706 7.706Z"
  }));
};
SvgDisabledIcon.displayName = "DisabledIcon";

exports.SvgDisabledIcon = SvgDisabledIcon;
